import { Menu } from "@base-ui/react/menu"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const TRIGGER_VARIANTS = {
  link: "btn-link",
  tertiary: "btn-tertiary",
  ghost: "btn-ghost",
  "ghost-tertiary": "btn-ghost-tertiary",
}

const Dropdown = ({
  label,
  value,
  options,
  onSelect,
  triggerVariant = "link",
  side = "bottom",
  align = "start",
}) => {
  const selectedOption = options.find((opt) => opt.value === value)

  return (
    <Menu.Root>
      <Menu.Trigger
        className={classNames(
          TRIGGER_VARIANTS[triggerVariant],
          "flex cursor-pointer items-center gap-1 text-sm"
        )}
      >
        {label}
        {selectedOption && `: ${selectedOption.label}`}
        {selectedOption?.icon && (
          <i className={`icon icon-${selectedOption.icon} text-xs`} />
        )}
        <i className="icon icon-chevron-down text-xs" />
      </Menu.Trigger>

      <Menu.Portal>
        <Menu.Positioner
          side={side}
          align={align}
          sideOffset={4}
          className="z-[100]"
        >
          <Menu.Popup className="min-w-44 rounded border bg-white py-1 shadow-lg">
            {options.map((option) => {
              const isSelected = option.value === value
              return (
                <Menu.Item
                  key={option.value}
                  onClick={(event) => onSelect(option.value, event)}
                  disabled={option.disabled}
                  className={classNames(
                    "flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-sm text-gray-700",
                    isSelected && "font-semibold text-blue-700",
                    option.disabled
                      ? "cursor-not-allowed opacity-50"
                      : "cursor-pointer hover:bg-gray-100"
                  )}
                >
                  {option.label}
                  {(option.menuIcon || option.icon) && (
                    <i
                      className={`icon icon-${
                        option.menuIcon || option.icon
                      } text-sm text-gray-500`}
                    />
                  )}
                </Menu.Item>
              )
            })}
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  )
}

Dropdown.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      icon: PropTypes.string,
      menuIcon: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  triggerVariant: PropTypes.oneOf([
    "link",
    "tertiary",
    "ghost",
    "ghost-tertiary",
  ]),
  side: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  align: PropTypes.oneOf(["start", "center", "end"]),
}

export default Dropdown
